<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101318"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.blMode.serialNumber')">
            <el-input
              v-model="editDialog.form.serialNumber"
              no="serialNumber"
              type="number"
              :disabled="true"
              min="1"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.blMode.code')">
            <el-input v-model="editDialog.form.code" no="code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.blMode.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.blMode.localName')">
            <el-input v-model="editDialog.form.localName" no="localName" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.blMode.interchangeCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.interchangeCode" no="interchangeCode" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.blMode.isoCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.isoCode" no="isoCode" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.blMode.blType')">
            <el-select v-model="editDialog.form.blType" no="blType">
              <el-option
                v-for="item in blTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoReleaseWay')">
            <el-select
              v-model="editDialog.form.releaseType"
              no="releaseType"
              :placeholder="''"
              size="mini"
            >
              <el-option
                v-for="(item,index) in ImportConstants._importReleaseTypes"
                :key="index"
                :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.blMode.remark')">
            <el-input v-model="editDialog.form.remark" no="remark" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('baseInfo.basicData.blMode.addBaseBlMode')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-bl-mode />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseBlMode from './baseBlMode'
import { getUserInfo } from '@/utils/auth'
import { getBlModeList, getBlModesByPlatform, saveBlMode, addBlModeByPlatform, saveBlModes, delBlMode } from '@/api/basicData/blMode'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ImportConstants from '@/class/cargo/model/parameters/ImportConstants'

export default {
  name: 'BlMode',
  components: { CargoAdvanceSelect, baseBlMode },
  data() {
    return {
      ImportConstants,
      isZh: this.$store.getters.language === 'zh',
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.localName'),
          field: 'localName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.interchangeCode'),
          field: 'interchangeCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.isoCode'),
          field: 'isoCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.blType'),
          field: 'blTypeStr',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.blMode.remark'),
          field: 'remark',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.CargoReleaseWay'),
          field: 'releaseType',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.releaseTypeLabelFunc(params.value)
          }
        }
      ],
      rowData: null,
      tenantId: '',
      blTypes: [],
      blTypeMap: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          blType: 1,
          releaseType: -1,
          remark: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
    this.blTypes.push({ label: 'MBL', value: 1 })
    this.blTypes.push({ label: 'MBL2', value: 2 })
    this.blTypes.push({ label: 'HBL', value: 3 })
    this.blTypes.push({ label: 'HBL2', value: 4 })
    this.blTypes.push({ label: 'AMS', value: 5 })
    this.blTypes.push({ label: 'MAWB', value: 6 })
    this.blTypes.push({ label: 'HAWB', value: 7 })
    this.blTypes.push({ label: 'HAWB2', value: 9 })
    this.blTypes.push({ label: 'AFR', value: 10 })
    this.blTypeMap = new Map()
    for (const item of this.blTypes) {
      this.blTypeMap.set(item.value, item.label)
    }
    document.blTypeMap = this.blTypeMap
  },
  beforeDestroy() {
    document.blTypeMap = undefined
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getBlModeList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getBlModesByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        for (const item of res.data.list) {
          // if (item.releaseType === -1) item.releaseType = ''
          item.blTypeStr = this.blTypeMap.get(item.blType)
        }
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          localName: '',
          interchangeCode: '',
          isoCode: '',
          blType: 1,
          releaseType: -1,
          remark: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_BLMode')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_BLMode')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.serialNumber && Number(form.serialNumber) != 0) {
        self.$message.warning(self.$t('baseInfo.basicData.blMode.serialNumberCheck'))
        return
      }
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.blMode.codeCheck'))
        return
      }
      if (!form.name) {
        self.$message.warning(self.$t('baseInfo.basicData.blMode.nameCheck'))
        return
      }
      if (!form.interchangeCode) {
        self.$message.warning(self.$t('baseInfo.basicData.blMode.interchangeCodeCheck'))
        return
      }
      if (!form.isoCode) {
        self.$message.warning(self.$t('baseInfo.basicData.blMode.isoCodeCheck'))
        return
      }
      let saveFunc = saveBlMode
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addBlModeByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delBlMode(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseBlMode) {
        document.resetBaseBlMode()
      } else {
        setTimeout(() => {
          document.resetBaseBlMode()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseBlModeRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          serialNumber: item.serialNumber,
          code: item.code,
          name: item.name,
          localName: item.localName,
          blType: item.blType,
          releaseType: item.releaseType,
          interchangeCode: item.interchangeCode,
          isoCode: item.isoCode,
          remark: item.remark
        })
      }
      saveBlModes(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    }
  }
}
</script>

<style>
</style>
